import type { NotificationId } from "@redotech/redo-ids-cockroach";

export enum NotificationType {
  NEW_MESSAGE = "NEW_MESSAGE",
  MESSAGE_DELETED = "MESSAGE_DELETED",
  TICKET_ASSIGNED = "TICKET_ASSIGNED",
  MENTIONED = "MENTIONED",
  CONVERSATION_UPDATED = "CONVERSATION_UPDATED",
  EMPTY_MESSAGE = "EMPTY_MESSAGE",
  INCOMING_CALL = "INCOMING_CALL",
  CONVERSION__SPLIT_AGENT_COMPLETED = "CONVERSION__SPLIT_AGENT_COMPLETED",
  KNOWLEDGE_CAPTURE_COMPLETED = "KNOWLEDGE_CAPTURE_COMPLETED",
  USER_NOTIFICATION_CREATED = "USER_NOTIFICATION_CREATED",
}

export type ConversationNotificationType =
  | NotificationType.NEW_MESSAGE
  | NotificationType.MESSAGE_DELETED
  | NotificationType.TICKET_ASSIGNED
  | NotificationType.MENTIONED
  | NotificationType.CONVERSATION_UPDATED;

interface BasicConversationNotification {
  type: ConversationNotificationType;
  conversationId: string;
}

interface EmptyNotification {
  type: NotificationType.EMPTY_MESSAGE;
}

export interface IncomingCallNotification {
  type: NotificationType.INCOMING_CALL;
  call_control_id: string;
  customerId: string;
  from_number: string;
  from_name?: string;
}

export interface Conversion_SplitAgentCompleted {
  type: NotificationType.CONVERSION__SPLIT_AGENT_COMPLETED;
  splitId: string;
}

export interface KnowledgeSuggestion {
  /** The ID of the concierge knowledge document in the database */
  knowledgeId: string;
  title: string;
  whenToUse: string;
  knowledge: string;
  expiresAt: string | null;
}

export interface KnowledgeCaptureCompletedNotification {
  type: NotificationType.KNOWLEDGE_CAPTURE_COMPLETED;
  conversationId: string;
  suggestions: KnowledgeSuggestion[];
  hasRelevantKnowledge: boolean;
}

export interface UserNotificationCreated {
  type: NotificationType.USER_NOTIFICATION_CREATED;
  notificationId: NotificationId;
}

export type Notification =
  | BasicConversationNotification
  | EmptyNotification
  | IncomingCallNotification
  | Conversion_SplitAgentCompleted
  | KnowledgeCaptureCompletedNotification
  | UserNotificationCreated;
